import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDanishFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "a",
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 256,
			cy: 256,
			r: 256,
			fill: "#fff"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#a)",
		children: [/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: 512,
			height: 512,
			fill: "#d80027"
		}), /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M134 0v223H0v67h134V512h67V289H512v-67H200V0h-67z"
		})]
	})]
});
export default SvgDanishFlag;
